import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringCheck',
})
export class StringCheckPipe implements PipeTransform {
  transform(value: string, isNumber: boolean = false): string {
    return value === null || value === '' || value === undefined ? isNumber? '0': '-' : value;
  }
}
